import React from "react";
import { motion } from "framer-motion";
import { ArrowRight, CheckCircle2 } from "lucide-react";
import { useLang } from "@/contexts/LangContext";

const ease = [0.22, 1, 0.36, 1];

export default function CTASection({ onOpenLead }) {
  const { t } = useLang();
  return (
    <section id="cta" data-testid="cta-section" className="relative py-28 lg:py-36 overflow-hidden">
      <div className="mx-auto max-w-6xl px-5 relative">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.85, ease }}
          className="relative rounded-[2rem] glass-strong p-8 sm:p-12 lg:p-16 overflow-hidden noise"
        >
          {/* Glows */}
          <div className="absolute -top-32 -left-20 h-80 w-80 rounded-full bg-brand-blue/20 blur-3xl pointer-events-none" />
          <div className="absolute -bottom-32 -right-20 h-80 w-80 rounded-full bg-brand-orange/15 blur-3xl pointer-events-none" />

          <div className="relative grid lg:grid-cols-[1fr_auto] gap-10 items-center">
            <div>
              <div className="text-[11px] sm:text-xs uppercase tracking-[0.24em] text-brand-orange font-mono-tight mb-5">
                {t.cta.eyebrow}
              </div>
              <h2 className="font-display text-4xl sm:text-5xl md:text-[48px] lg:text-[56px] font-black tracking-tighter text-white leading-[1.02]">
                {t.cta.title}{" "}
                <span className="text-gradient-brand">{t.cta.title2}</span>
              </h2>
              <p className="mt-6 text-white/70 leading-relaxed max-w-2xl text-[15px] sm:text-base lg:text-lg">
                {t.cta.desc}
              </p>
              <div className="mt-7 flex flex-wrap gap-2">
                {t.cta.tags.map((tag) => (
                  <span
                    key={tag}
                    className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-white/[0.04] border border-white/10 text-[12px] text-white/75"
                  >
                    <CheckCircle2 className="h-3.5 w-3.5 text-brand-blue" strokeWidth={2} />
                    {tag}
                  </span>
                ))}
              </div>
            </div>
            <button
              onClick={onOpenLead}
              data-testid="cta-section-button"
              className="group inline-flex items-center gap-2 px-7 py-4 rounded-full text-sm font-semibold text-white btn-primary-glow whitespace-nowrap"
            >
              {t.cta.button}
              <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" />
            </button>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
